import { render, staticRenderFns } from "./CreditNoteModal.vue?vue&type=template&id=c5da6f50&scoped=true"
import script from "./CreditNoteModal.vue?vue&type=script&lang=js"
export * from "./CreditNoteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5da6f50",
  null
  
)

export default component.exports